<template>
  <div>
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BASE_API from '@/api/dataBase.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import API from '@/api/financeCenter/saleInvoice.js';
  import { filterEmpty } from '@/common/js/util';
  import { handleExport } from '../saleInvoice/components/actions';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    mixins: [tableMixins],
    name: 'transactionTypeList',
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        load: false,
        menuButtonList: [],
        tableData: [],
        query: {},
        multipleSelection: [],
        columnList: [],
        dicts: {
          revAccount: [],
          invAccount: [],
          costAccount: [],
          shipAccount: [],
        },
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'transactionTypeCode',
            title: 'saleInvoice.transactionTypeCode',
            visible: true,
            fixed: 'left',
          },
          {
            field: 'transactionTypeName',
            title: 'saleInvoice.transactionTypeName',
            visible: true,
            fixed: 'left',
          },
          { field: 'tradeTypeName', title: 'saleInvoice.tradeType', visible: true, width: 100 },
          { field: 'revAccountName', title: 'saleInvoice.revAccount', visible: true, width: 220 },
          { field: 'invAccountName', title: 'saleInvoice.invAccount', visible: true, width: 160 },
          { field: 'costAccountName', title: 'saleInvoice.costAccount', visible: true, width: 220 },
          { field: 'shipAccountName', title: 'saleInvoice.shipAccount', visible: true, width: 220 },
          { field: 'createDate', title: 'saleInvoice.createDate', visible: true },
          {
            field: 'createPersonName',
            title: 'saleInvoice.createPersonName',
            visible: true,
            width: 80,
          },
          {
            field: 'transactionTypeStatusName',
            title: 'saleInvoice.transactionTypeStatus',
            visible: true,
            width: 80,
          },
          { field: 'lastModifyDate', title: 'saleInvoice.lastModifyDate', visible: true },
          {
            field: 'lastModifyPersonName',
            title: 'saleInvoice.lastModifyPersonName',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        return [
          {
            type: 'input',
            prop: 'transactionTypeName',
            name: this.$t('saleInvoice.transactionTypeName'),
          },
          {
            type: 'select',
            prop: 'revAccount',
            name: this.$t('saleInvoice.revAccount'),
            options: this.dicts.revAccount,
            label: 'accountDesc',
            value: 'accountCode',
          },
          {
            type: 'dict',
            prop: 'transactionTypeStatus',
            name: this.$t('saleInvoice.transactionTypeStatus'),
            dictType: 'transaction_type_status',
          },
          {
            type: 'select',
            prop: 'invAccount',
            name: this.$t('saleInvoice.invAccount'),
            options: this.dicts.invAccount,
            label: 'accountDesc',
            value: 'accountCode',
          },
          {
            type: 'startDaterangePicker',
            prop: 'createDateBegin',
            name: this.$t('saleInvoice.createDateStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'createDateEnd',
            name: this.$t('saleInvoice.createDateEnd'),
          },
          {
            type: 'select',
            prop: 'costAccount',
            name: this.$t('saleInvoice.costAccount'),
            options: this.dicts.costAccount,
            label: 'accountDesc',
            value: 'accountCode',
          },
          {
            type: 'dict',
            prop: 'tradeType',
            name: this.$t('saleInvoice.tradeType'),
            dictType: 'sale-trade-type',
          },
        ];
      },
    },
    mounted() {
      this.getAccountList(); //获取科目
      this.initQuery();
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
      });
    },
    methods: {
      handleExport,
      chooseClick(type) {
        if (type == 'add') {
          this.handlePath();
          return;
        }
        const selectedList = this.$refs['siruiTable'].getCheckboxRecords(); // 选中数据
        if (type == 'export') {
          this.handleExport(selectedList, API.EXPORT_TYPE);
          return;
        }
        if (selectedList.length == 0) {
          this.errorTip(this.$t('xTable.noSelectData'));
          return;
        }
        if (type == 'edit') {
          this.handlePath(selectedList[0].id);
          return;
        }
        if (type == 'enable' || type == 'disable') {
          const status = type == 'enable' ? 'Disabled' : 'Enable'; // 启用针对失效数据
          const notSame = selectedList.some((item) => {
            return item.transactionTypeStatus !== status;
          });
          if (notSame) {
            const message = type == 'enable' ? '请选择失效数据' : '请选择启用数据';
            this.errorTip(message);
          } else {
            this.changStatus(selectedList, type);
          }
        }
      },
      changStatus(selectedList, type) {
        this.load = true;
        const transactionTypeStatus = type == 'enable' ? 'Enable' : 'Disabled';
        let length;
        let tradeTypes;
        const params = selectedList.map((item) => {
          return {
            transactionTypeStatus,
            id: item.id,
            version: item.version,
          };
        });
        // 如果是启用，需要判断贸易类型是否存在，存在需要提示：已经存在有效的贸易类型：XXX
        if (type === 'enable') {
          tradeTypes = selectedList.map((item) => {
            return item.tradeType;
          });
          length = tradeTypes.length;
        }
        if (length) {
          this.$axios
            .post(API.LIST_TRANSACTION_TYPE_BYPAGE, {
              tradeTypes,
              transactionTypeStatus: 'Enable',
            })
            .then((res) => {
              if (res.data.code == 0) {
                const data = res.data.data.records;
                if (data.length > 0) {
                  this.load = false;
                  this.$alert('选择的贸易类型已经存在有效的');
                } else {
                  // 不存在
                  this.changStatusPost(params);
                }
              }
            });
        } else {
          this.changStatusPost(params);
        }
      },
      changStatusPost(params) {
        this.$axios.post(API.UPDATE_TRANSACTION_TYPE_STATUS, params).then((res) => {
          if (res.data.code == 0) {
            this.getData();
            this.load = false;
          } else {
            this.$alert(res.data.msg);
            this.load = false;
          }
        });
      },
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query);
      },
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        return filterEmpty(result);
      },
      getData(search) {
        const params = this.getQuery();
        if (search && Object.keys(params).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        this.load = true;
        // 获取数据
        this.$axios
          .post(API.LIST_TRANSACTION_TYPE_BYPAGE, params)
          .then((res) => {
            this.load = false;
            if (res.data.code === 0) {
              this.tableData = res.data.data.records;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      errorTip(message) {
        this.$message({
          showClose: true,
          message,
          type: 'error',
        });
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData(true);
      },
      // 列表双击
      dblclickEvent(value) {
        const row = value.row;
        this.handlePath(row.id);
      },
      handlePath(id) {
        let pathRoute = {
          path: '/transactionType/set',
          name: 'transactionTypeSet',
          meta: {
            keepAlive: true,
            title: '事务处理类型设置',
          },
          query: { id },
        };
        this.$store.dispatch('tagsView/addTabView', pathRoute).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathRoute);
          });
        });
      },
      //获取科目列表
      getAccountList() {
        let ledgerEntityCode = this.userInfo.companyCode;
        this.$axios.post(BASE_API.GET_ACCOUNTDETAIL, { ledgerEntityCode }).then((res) => {
          if (res.data.code === 0) {
            let accountList = res.data.data;
            this.dicts.revAccount = accountList.filter((it) => it.accountGroup == '6000'); //收入成本类科目
            this.dicts.invAccount = accountList.filter((it) => it.accountGroup == '1000'); //库存科目,是资产科目
            this.dicts.costAccount = accountList.filter((it) => it.accountGroup == '6000'); //成本科目
            this.dicts.shipAccount = accountList.filter((it) => it.accountGroup == '1000'); //发出商品科目
          }
        });
      },
    },
  };
</script>
